var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['table-layout', _vm.fullWidth ? 'table-layout-full-width' : null, _vm.borderCollapse ? 'table-layout-collapse' : null, _vm.fullHeight ? 'table-layout-full-height' : null, _vm.equalCells ? 'table-layout-fixed' : null, ("table-layout-v-align-" + _vm.yAlign), ("table-layout-x-align-" + _vm.xAlign)]},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c9ba90c4","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/table-layout/table-layout.vue
// module id = null
// module chunks = 